<template>
  <iframe
    :src="iframeUrlMeta"
    frameborder="0"
    style="width: 100%; height: 90%"
    allowtransparency
  ></iframe>
  <Footer>
    <Button severity="secondary" class="text-sm font-medium" @click="goBack"
      >Volver</Button
    >
  </Footer>
</template>
<script setup lang="ts">
  import router from '@/router'
  import useMetabase, { ReportType } from '@/shared/composables/useMetabase'
  import Footer from '@/shared/components/Footer.vue'
  import { onMounted, ref } from 'vue'
  import useLoading from '@/store/load'

  const loadingStore = useLoading()
  const iframeUrlMeta = ref<string>()

  onMounted(async () => {
    loadingStore.setLoadingState()
    iframeUrlMeta.value = await useMetabase(ReportType.VACATION)
    loadingStore.dismissLoadingState()
  })

  const goBack = () => {
    router.back()
  }
</script>
